var _linearGradient;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcvcmFullRes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 600,
    height: 94.720001,
    viewBox: "0 0 600 94.720001",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient50"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#373795",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop50"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#2e2a66",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop51"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    href: "#linearGradient50",
    id: "linearGradient51",
    x1: 36.376446,
    y1: 108.2742,
    x2: 126.53726,
    y2: 178.93738,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.7817645,-89.779521)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 567.67901,38.609485 v -11.68 h 1.76 1.76 v 10.08 10.08 h 5.28 5.28 v 1.6 1.6 h -7.04 -7.04 z",
    id: "path49"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 559.03901,38.609485 v -11.68 h 1.76 1.76 v 11.68 11.68 h -1.76 -1.76 z",
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 509.75901,38.609485 v -11.68 l 1.84,0.0213 1.84,0.0213 6.4,8.65753 6.4,8.65754 0.0851,-8.67887 0.0851,-8.67886 h 1.75485 1.75486 v 11.68 11.68 l -1.68,-6.4e-4 -1.68,-6.4e-4 -6.64,-8.99463 -6.64,-8.99463 v 8.99527 8.99527 h -1.76 -1.76 z",
    id: "path47"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 409.27901,45.350425 v -4.93905 l -4.48,-6.60189 c -2.464,-3.63104 -4.48,-6.66446 -4.48,-6.74094 0,-0.0765 0.84311,-0.13906 1.87358,-0.13906 h 1.87359 l 3.30386,4.97662 c 1.81713,2.73714 3.42173,5.04947 3.56579,5.1385 0.14405,0.089 1.77345,-2.15045 3.62089,-4.97663 l 3.35897,-5.13849 h 1.95847 1.95846 l -0.5658,0.88 c -0.31119,0.484 -2.34375,3.52288 -4.5168,6.75306 l -3.95101,5.87306 v 4.92694 4.92694 h -1.76 -1.76 z",
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 388.15901,40.219965 v -10.06952 l -3.6,-0.0905 -3.6,-0.0905 -0.0975,-1.52 -0.0975,-1.52 h 8.97754 8.97746 v 1.6 1.6 h -3.52 -3.52 v 10.08 10.08 h -1.76 -1.76 z",
    id: "path45"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 373.75901,38.609485 v -11.68 h 1.76 1.76 v 11.68 11.68 h -1.76 -1.76 z",
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 351.67901,38.609485 v -11.68 h 5.54192 c 6.22177,0 8.05575,0.35178 9.70483,1.86151 3.47475,3.18112 2.84693,9.21086 -1.17254,11.26144 -0.68679,0.35038 -1.48586,0.63705 -1.7757,0.63705 -0.70606,0 -0.63468,0.14362 2.54488,5.12 l 2.76018,4.32 -1.64364,0.0982 c -0.904,0.054 -1.80481,0.0363 -2.00179,-0.0394 -0.19698,-0.0756 -1.58214,-2.0982 -3.07814,-4.4946 l -2.72,-4.35707 -2.32,-0.004 -2.32,-0.004 v 4.48 4.48 h -1.76 -1.76 z m 12.06446,-1.10704 c 2.35976,-1.43883 2.6458,-4.45792 0.59998,-6.33277 l -1.13504,-1.04019 h -4.0047 -4.0047 v 4 4 l 3.76,-0.001 c 3.16462,-10e-4 3.92222,-0.10011 4.78446,-0.62585 z",
    id: "path43"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 306.55901,38.609485 v -11.68 h 7.84 7.84 v 1.6 1.6 h -6.08 -6.08 v 3.36 3.36 h 5.92 5.92 v 1.6 1.6 h -5.92 -5.92 v 3.52 3.52 h 6.08 6.08 v 1.6 1.6 h -7.84 -7.84 z",
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 291.83901,40.219965 v -10.06952 l -3.6,-0.0905 -3.6,-0.0905 -0.0975,-1.52 -0.0975,-1.52 h 8.97754 8.97746 v 1.6 1.6 h -3.52 -3.52 v 10.08 10.08 h -1.76 -1.76 z",
    id: "path41"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 261.11901,38.609485 v -11.68 l 1.84,0.0213 1.84,0.0213 6.4,8.65753 6.4,8.65754 0.0851,-8.67887 0.0851,-8.67886 h 1.75485 1.75486 v 11.68 11.68 l -1.68,-6.4e-4 -1.68,-6.4e-4 -6.64,-8.99463 -6.64,-8.99463 v 8.99527 8.99527 h -1.76 -1.76 z",
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 252.15901,38.609485 v -11.68 h 1.76 1.76 v 11.68 11.68 h -1.76 -1.76 z",
    id: "path39"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 223.03901,38.609485 v -11.68 h 7.84 7.84 v 1.6 1.6 h -6.08 -6.08 v 3.36 3.36 h 5.92 5.92 v 1.6 1.6 h -5.92 -5.92 v 3.52 3.52 h 6.08 6.08 v 1.6 1.6 h -7.84 -7.84 z",
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 197.75901,38.609485 v -11.68 h 1.76 1.76 v 4.8 4.8 h 6.56 6.56 v -4.8 -4.8 h 1.76 1.76 v 11.68 11.68 h -1.76 -1.76 v -5.28 -5.28 h -6.56 -6.56 v 5.28 5.28 h -1.76 -1.76 z",
    id: "path37"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 183.35901,40.219965 v -10.06952 l -3.6,-0.0905 -3.6,-0.0905 -0.0975,-1.52 -0.0975,-1.52 h 8.97754 8.97746 v 1.6 1.6 h -3.52 -3.52 v 10.08 10.08 h -1.76 -1.76 z",
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 543.19901,50.165855 c -3.36389,-0.9004 -5.37028,-2.25827 -7.02967,-4.7575 -3.13965,-4.72865 -2.52579,-11.35671 1.41598,-15.28909 4.41247,-4.40195 12.08044,-4.56303 16.30104,-0.34243 0.72196,0.72196 1.31146,1.42065 1.31001,1.55265 -10e-4,0.132 -0.60247,0.56574 -1.33561,0.96387 l -1.33296,0.72388 -0.9844,-1.01221 c -1.97229,-2.028 -5.18946,-2.72757 -8.30726,-1.80638 -1.96836,0.58157 -4.49101,3.22759 -5.13068,5.3816 -1.09836,3.69857 -0.36346,6.89924 2.16,9.4074 1.84829,1.83708 3.31369,2.42581 6.01068,2.41481 2.04014,-0.008 3.89748,-0.78003 5.26726,-2.18851 l 0.9844,-1.01221 1.33296,0.72388 c 0.73314,0.39813 1.33416,0.83187 1.33561,0.96387 0.006,0.5816 -2.77041,2.93295 -4.2796,3.62387 -2.08491,0.95451 -5.50818,1.24393 -7.71776,0.6525 z",
    id: "path35"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 491.94901,50.296415 c -2.9761,-0.63397 -4.99565,-2.23819 -6.25284,-4.96693 -0.69999,-1.51932 -0.74238,-2.02356 -0.84072,-10 l -0.10355,-8.4 h 1.76389 1.76389 l 0.0997,8.24 c 0.11125,9.1971 0.17364,9.48958 2.38402,11.17552 0.94783,0.72295 1.56884,0.91143 3.33112,1.011 1.19135,0.0673 2.67604,-0.0459 3.29932,-0.2516 1.40905,-0.46503 2.94307,-2.1713 3.38597,-3.76617 0.19061,-0.68638 0.33644,-4.49313 0.33746,-8.80875 l 0.002,-7.6 h 1.78356 1.78355 l -0.12907,8.4 c -0.092,5.98568 -0.25429,8.75194 -0.56476,9.62448 -0.64178,1.8037 -2.6102,3.86353 -4.4473,4.65383 -1.81948,0.78272 -5.56167,1.12198 -7.59598,0.68862 z",
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 465.72173,50.157755 c -3.48779,-0.84643 -6.54714,-3.52291 -7.84268,-6.86116 -0.98701,-2.54328 -0.98403,-6.83831 0.007,-9.39159 1.41229,-3.64035 4.6826,-6.25803 8.75589,-7.00856 5.5608,-1.02462 11.10848,1.95001 13.07097,7.00856 0.99056,2.55328 0.99354,6.84831 0.007,9.39159 -2.09696,5.40333 -8.02691,8.31006 -13.99724,6.86116 z m 6.88376,-3.59146 c 1.97141,-0.9824 3.34262,-2.69008 4.03667,-5.02722 1.81994,-6.1284 -1.92194,-11.73523 -7.82598,-11.72643 -3.96276,0.006 -6.73397,2.07448 -7.86032,5.86733 -1.82227,6.13624 1.91778,11.72955 7.84315,11.72955 1.64276,0 2.49175,-0.18807 3.80648,-0.84323 z",
    id: "path33"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 442.07901,50.165755 c -3.36389,-0.9004 -5.37028,-2.25827 -7.02967,-4.7575 -3.13965,-4.72865 -2.52579,-11.35671 1.41598,-15.28909 4.42307,-4.41252 12.07031,-4.57316 16.30104,-0.34243 0.72196,0.72196 1.31146,1.42065 1.31001,1.55265 -10e-4,0.132 -0.60247,0.56574 -1.33561,0.96387 l -1.33296,0.72388 -0.9844,-1.01221 c -1.97229,-2.028 -5.18946,-2.72757 -8.30726,-1.80638 -1.96836,0.58157 -4.49101,3.22759 -5.13068,5.3816 -1.09836,3.69857 -0.36346,6.89924 2.16,9.4074 1.84829,1.83708 3.31369,2.42581 6.01068,2.41481 2.04014,-0.008 3.89748,-0.78003 5.26726,-2.18851 l 0.9844,-1.01221 1.33296,0.72388 c 0.73314,0.39813 1.33416,0.83187 1.33561,0.96387 0.006,0.5816 -2.77041,2.93295 -4.2796,3.62387 -2.08491,0.95451 -5.50818,1.24393 -7.71776,0.6525 z",
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 335.44531,50.291385 c -3.91988,-0.82954 -6.61085,-2.8698 -8.30426,-6.29618 -1.12654,-2.2794 -1.20052,-2.61148 -1.19146,-5.34806 0.0122,-3.68627 0.81118,-5.89533 2.94502,-8.14266 4.49463,-4.73367 12.28239,-5.10115 17.03882,-0.804 0.69607,0.62885 1.26447,1.23462 1.26312,1.34614 -10e-4,0.11152 -0.59212,0.53956 -1.31281,0.9512 l -1.31035,0.74843 -0.84719,-0.80957 c -2.28777,-2.18618 -6.45849,-2.78633 -9.50498,-1.36772 -4.38478,2.04179 -6.18828,7.71064 -3.88783,12.22044 1.5778,3.09314 4.09803,4.61764 7.58562,4.58861 2.15939,-0.018 3.28295,-0.32934 5.04344,-1.39762 1.00508,-0.6099 1.03656,-0.69493 1.03656,-2.8 v -2.17101 h -3.85753 -3.85754 l 0.0975,-1.52 0.0975,-1.52 5.52,-0.0876 5.52,-0.0876 v 4.30036 4.30036 l -1.47293,1.29653 c -0.81011,0.71308 -2.25372,1.58865 -3.20803,1.9457 -2.02636,0.75816 -5.46394,1.06234 -7.39274,0.65416 z",
    id: "path31"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 575.03901,69.649385 v -5.6 h -1.92 c -1.83467,0 -1.92,-0.0356 -1.92,-0.8 v -0.8 h 4.8 4.8 v 0.8 c 0,0.76444 -0.0853,0.8 -1.92,0.8 h -1.92 v 5.6 5.6 h -0.96 -0.96 z",
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 559.35901,68.849385 v -6.4 h 4.32 4.32 v 0.8 0.8 h -3.36 -3.36 v 1.92 1.92 h 3.2 3.2 v 0.8 0.8 h -3.2 -3.2 v 2.08 2.08 h 3.36 3.36 v 0.8 0.8 h -4.32 -4.32 z",
    id: "path29"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 545.91901,68.849385 v -6.4 h 0.94841 0.94841 l 0.0916,3.11025 0.0916,3.11025 2.5405,-3.03025 c 1.39728,-1.66664 2.57143,-3.07641 2.60924,-3.13282 0.0378,-0.0564 0.54302,-0.0564 1.1227,0 l 1.05396,0.10257 -2.4632,2.82151 c -1.35476,1.55183 -2.4632,2.94282 -2.4632,3.09109 0,0.14826 1.23397,1.72258 2.74216,3.49848 l 2.74216,3.22892 h -1.11344 c -1.10882,0 -1.6161,-0.49532 -5.54204,-5.41137 -0.0577,-0.0722 -0.3938,0.13006 -0.74688,0.44959 -0.52351,0.47377 -0.64196,0.98514 -0.64196,2.77138 v 2.1904 h -0.96 -0.96 z",
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 532.15901,68.849385 v -6.4 l 3.12,5e-4 c 2.32922,3.7e-4 3.40387,0.1423 4.24,0.56 1.46845,0.73357 2.38718,2.55461 2.08947,4.14156 -0.23699,1.26325 -1.7235,2.97794 -2.58166,2.97794 -0.48759,0 -0.49463,0.0716 -0.0707,0.72 0.25887,0.396 0.99986,1.548 1.64663,2.56 l 1.17597,1.84 -1.04984,-0.002 c -0.95811,-0.002 -1.18181,-0.21115 -2.56048,-2.4 -1.47245,-2.33772 -1.54327,-2.39838 -2.8,-2.39838 h -1.28939 v 2.4 2.4 h -0.96 -0.96 z m 6.83685,-0.66323 c 0.61152,-0.48102 0.84315,-0.95814 0.84315,-1.73677 0,-1.64815 -1.16636,-2.4 -3.72315,-2.4 h -2.03685 v 2.4 2.4 h 2.03685 c 1.57607,0 2.22758,-0.15003 2.88,-0.66323 z",
    id: "path27"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 519.04662,68.929385 2.48927,-6.32 h 1.18312 1.18312 l 2.48927,6.32 2.48926,6.32 h -1.02961 c -0.91746,0 -1.07561,-0.13941 -1.45204,-1.28 l -0.42244,-1.28 h -3.25756 -3.25756 l -0.42244,1.28 c -0.37643,1.14059 -0.53458,1.28 -1.45204,1.28 h -1.02961 z m 6.07006,1.76 c -0.004,-0.71085 -2.16675,-6.16197 -2.42014,-6.10027 -0.2706,0.0659 -2.37148,5.4616 -2.3752,6.10027 -0.002,0.28465 0.68976,0.4 2.39767,0.4 1.70791,0 2.39933,-0.11535 2.39767,-0.4 z",
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 500.15901,68.830985 v -6.4184 l 1.34749,0.0984 1.34749,0.0984 1.74988,4.4 c 0.96243,2.42 1.84224,4.4 1.95514,4.4 0.1129,0 0.99271,-1.98 1.95514,-4.4 l 1.74988,-4.4 1.34749,-0.0984 1.34749,-0.0984 v 6.4184 6.4184 h -0.95187 -0.95188 l -0.0881,-5.02186 -0.0881,-5.02186 -1.96334,4.94186 c -1.07983,2.71802 -2.14033,4.94186 -2.35666,4.94186 -0.21633,0 -1.27683,-2.22384 -2.35666,-4.94186 l -1.96334,-4.94186 -0.0881,5.02186 -0.0881,5.02186 h -0.95198 -0.95187 z",
    id: "path25"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 478.07901,68.849385 v -6.4 h 0.94159 c 0.84432,0 1.3071,0.49913 4.48,4.83199 l 3.53841,4.83199 v -4.83199 -4.83199 h 0.96 0.96 v 6.4 6.4 h -0.90352 c -0.79834,0 -1.31054,-0.56611 -4.4,-4.86311 l -3.49648,-4.86311 -0.0883,4.86311 -0.0883,4.86311 h -0.95173 -0.95167 z",
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 447.67901,68.848685 v -6.4529 l 3.81518,0.1068 c 3.51502,0.0984 3.87968,0.16747 4.6351,0.87798 1.06601,1.00263 1.35467,2.54427 0.70988,3.79117 -0.27307,0.52805 -0.72294,1.04699 -0.99972,1.1532 -0.40397,0.15502 -0.29585,0.3784 0.54817,1.13253 0.89742,0.80185 1.05139,1.15308 1.05139,2.3984 0,1.16727 -0.17722,1.63637 -0.88637,2.34625 -0.85986,0.86073 -1.00585,0.89044 -4.88,0.99337 l -3.99363,0.1061 z m 7.2888,4.30256 c 0.90509,-0.63396 0.94086,-2.1522 0.0712,-3.02186 -0.52622,-0.52622 -1.06667,-0.64 -3.04,-0.64 h -2.4 v 2.08 2.08 h 2.3288 c 1.58983,0 2.55447,-0.15807 3.04,-0.49814 z m -0.194,-5.79146 c 0.32186,-0.29127 0.5852,-0.93111 0.5852,-1.42185 0,-1.348 -1.0279,-1.88855 -3.5912,-1.88855 h -2.1688 v 1.92 1.92 h 2.2948 c 1.68628,0 2.44999,-0.14044 2.88,-0.5296 z",
    id: "path23"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 434.23901,68.849385 v -6.4 l 3.12,5e-4 c 2.32922,3.7e-4 3.40387,0.1423 4.24,0.56 1.46845,0.73357 2.38718,2.55461 2.08947,4.14156 -0.23699,1.26325 -1.7235,2.97794 -2.58166,2.97794 -0.48759,0 -0.49463,0.0716 -0.0707,0.72 0.25887,0.396 0.99986,1.548 1.64663,2.56 l 1.17597,1.84 -1.04984,-0.002 c -0.95811,-0.002 -1.18181,-0.21115 -2.56048,-2.4 -1.47245,-2.33772 -1.54327,-2.39838 -2.8,-2.39838 h -1.28939 v 2.4 2.4 h -0.96 -0.96 z m 6.83685,-0.66323 c 0.61152,-0.48102 0.84315,-0.95814 0.84315,-1.73677 0,-1.64815 -1.16636,-2.4 -3.72315,-2.4 h -2.03685 v 2.4 2.4 h 2.03685 c 1.57607,0 2.22758,-0.15003 2.88,-0.66323 z",
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 421.12662,68.929385 2.48927,-6.32 h 1.18312 1.18312 l 2.48927,6.32 2.48926,6.32 h -1.02961 c -0.91746,0 -1.07561,-0.13941 -1.45204,-1.28 l -0.42244,-1.28 h -3.25756 -3.25756 l -0.42244,1.28 c -0.37643,1.14059 -0.53458,1.28 -1.45204,1.28 h -1.02961 z m 6.07006,1.76 c -0.004,-0.71085 -2.16675,-6.16197 -2.42014,-6.10027 -0.2706,0.0659 -2.37148,5.4616 -2.3752,6.10027 -0.002,0.28465 0.68976,0.4 2.39767,0.4 1.70791,0 2.39933,-0.11535 2.39767,-0.4 z",
    id: "path21"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 388.15901,72.518715 v -2.73066 l -2.18231,-3.26934 c -1.20028,-1.79813 -2.28878,-3.44933 -2.41889,-3.66933 -0.16815,-0.28431 0.046,-0.4 0.74022,-0.4 0.87048,0 1.17382,0.29605 2.78692,2.72 0.99557,1.496 1.92207,2.72 2.05889,2.72 0.13682,0 1.01521,-1.22118 1.95197,-2.71373 1.57515,-2.50971 1.78281,-2.7142 2.76209,-2.72 0.76101,-0.005 0.99233,0.10625 0.82231,0.39373 -0.13011,0.22 -1.21861,1.8712 -2.41889,3.66933 l -2.18231,3.26934 v 2.73066 2.73067 h -0.96 -0.96 z",
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 371.19901,68.849385 v -6.4 l 3.12,5e-4 c 2.32922,3.7e-4 3.40387,0.1423 4.24,0.56 1.46845,0.73357 2.38718,2.55461 2.08947,4.14156 -0.23699,1.26325 -1.7235,2.97794 -2.58166,2.97794 -0.48759,0 -0.49463,0.0716 -0.0707,0.72 0.25887,0.396 0.99986,1.548 1.64663,2.56 l 1.17597,1.84 -1.04984,-0.002 c -0.95811,-0.002 -1.18181,-0.21115 -2.56048,-2.4 -1.47245,-2.33772 -1.54327,-2.39838 -2.8,-2.39838 h -1.28939 v 2.4 2.4 h -0.96 -0.96 z m 6.83685,-0.66323 c 0.61152,-0.48102 0.84315,-0.95814 0.84315,-1.73677 0,-1.64815 -1.16636,-2.4 -3.72315,-2.4 h -2.03685 v 2.4 2.4 h 2.03685 c 1.57607,0 2.22758,-0.15003 2.88,-0.66323 z",
    id: "path19"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 358.08662,68.929385 2.48927,-6.32 h 1.18312 1.18312 l 2.48927,6.32 2.48926,6.32 h -1.02961 c -0.91746,0 -1.07561,-0.13941 -1.45204,-1.28 l -0.42244,-1.28 -3.22878,0.003 -3.22878,0.003 -0.53624,1.27675 c -0.4534,1.07953 -0.68214,1.27674 -1.48082,1.27674 h -0.94459 z m 6.07006,1.76 c -0.004,-0.71085 -2.16675,-6.16197 -2.42014,-6.10027 -0.2706,0.0659 -2.37148,5.4616 -2.3752,6.10027 -0.002,0.28465 0.68976,0.4 2.39767,0.4 1.70791,0 2.39933,-0.11535 2.39767,-0.4 z",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 348.47901,69.649385 v -5.6 h -1.92 c -1.83467,0 -1.92,-0.0356 -1.92,-0.8 v -0.8 h 4.8 4.8 v 0.8 c 0,0.76444 -0.0853,0.8 -1.92,0.8 h -1.92 v 5.6 5.6 h -0.96 -0.96 z",
    id: "path17"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 329.91901,68.849385 v -6.4 h 0.94159 c 0.84432,0 1.3071,0.49913 4.48,4.83199 l 3.53841,4.83199 v -4.83199 -4.83199 h 0.96 0.96 v 6.4 6.4 h -0.90352 c -0.79834,0 -1.31054,-0.56611 -4.4,-4.86311 l -3.49648,-4.86311 -0.0883,4.86311 -0.0883,4.86311 h -0.95173 -0.95167 z",
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 303.35901,68.849385 v -6.4 h 0.96 0.96 v 5.6 5.6 h 2.88 c 2.85867,0 2.88,0.006 2.88,0.8 v 0.8 h -3.84 -3.84 z",
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 276.57616,74.708855 c -0.11974,-0.31871 -1.25411,-3.20747 -2.52082,-6.41947 l -2.30312,-5.84 h 1.0318 1.03181 l 1.8595,5.04 c 1.02272,2.772 1.96622,5.16108 2.09666,5.30907 0.21404,0.24284 1.53295,-2.89591 3.5083,-8.34907 0.68585,-1.89336 0.77982,-2 1.76242,-2 h 1.03795 l -2.48717,6.32 -2.48717,6.32 -1.15623,0.0995 c -0.88047,0.0757 -1.20814,-0.0387 -1.37393,-0.48 z",
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 253.43901,68.849385 v -6.4 h 4.32 4.32 v 0.8 0.8 h -3.36 -3.36 v 1.92 1.92 h 3.2 3.2 v 0.8 0.8 h -3.2 -3.2 v 2.08 2.08 h 3.36 3.36 v 0.8 0.8 h -4.32 -4.32 z",
    id: "path13"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 238.07901,68.849385 v -6.4 h 0.96 0.96 v 2.72 2.72 h 3.52 3.52 v -2.72 -2.72 h 0.96 0.96 v 6.4 6.4 h -0.96 -0.96 v -2.88 -2.88 h -3.52 -3.52 v 2.88 2.88 h -0.96 -0.96 z",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 228.47901,69.649385 v -5.6 h -1.92 c -1.83467,0 -1.92,-0.0356 -1.92,-0.8 v -0.8 h 4.8 4.8 v 0.8 c 0,0.76444 -0.0853,0.8 -1.92,0.8 h -1.92 v 5.6 5.6 h -0.96 -0.96 z",
    id: "path11"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 205.11901,68.849385 v -6.4 l 3.12,5e-4 c 2.32922,3.7e-4 3.40387,0.1423 4.24,0.56 1.46845,0.73357 2.38718,2.55461 2.08947,4.14156 -0.23699,1.26325 -1.7235,2.97794 -2.58166,2.97794 -0.48759,0 -0.49463,0.0716 -0.0707,0.72 0.25887,0.396 0.99986,1.548 1.64663,2.56 l 1.17597,1.84 -1.04984,-0.002 c -0.95811,-0.002 -1.18181,-0.21115 -2.56048,-2.4 -1.47245,-2.33772 -1.54327,-2.39838 -2.8,-2.39838 h -1.28939 v 2.4 2.4 h -0.96 -0.96 z m 6.83685,-0.66323 c 0.61152,-0.48102 0.84315,-0.95814 0.84315,-1.73677 0,-1.64815 -1.16636,-2.4 -3.72315,-2.4 h -2.03685 v 2.4 2.4 h 2.03685 c 1.57607,0 2.22758,-0.15003 2.88,-0.66323 z",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 176.31901,68.849385 v -6.4 h 4.32 4.32 v 0.8 0.8 h -3.36 -3.36 v 1.92 1.92 h 3.2 3.2 v 0.8 0.8 h -3.2 -3.2 v 2.88 2.88 h -0.96 -0.96 z",
    id: "path9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 465.75901,75.164705 c -2.73382,-0.93 -4.13633,-3.07134 -4.13633,-6.31532 0,-3.51457 1.54824,-5.62054 4.71898,-6.41894 2.78016,-0.70005 5.7358,0.54371 6.95058,2.92487 1.78007,3.48924 0.67977,7.78259 -2.40222,9.37341 -1.42395,0.735 -3.68682,0.92727 -5.13101,0.43598 z m 4.35268,-1.9217 c 3.02317,-2.01961 2.96155,-7.00275 -0.10976,-8.87535 -3.00955,-1.83495 -6.64193,0.61605 -6.64193,4.48173 0,2.80079 2.02887,5.12 4.47901,5.12 0.69967,0 1.63087,-0.29763 2.27268,-0.72638 z",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 409.5235,75.250705 c -2.94011,-0.88528 -4.55523,-3.15216 -4.56088,-6.40137 -0.003,-1.6784 0.16024,-2.3587 0.84501,-3.52344 1.9725,-3.35507 6.93636,-4.16391 9.44401,-1.53887 0.87491,0.91587 0.88567,0.96578 0.30084,1.39537 -0.5362,0.39388 -0.71529,0.35401 -1.54466,-0.34386 -3.08251,-2.59377 -7.28881,-0.27918 -7.28881,4.0108 0,2.58773 1.47265,4.56701 3.71036,4.9868 1.42101,0.26659 2.42817,-0.008 3.57845,-0.97601 0.8253,-0.69444 1.01058,-0.73642 1.54042,-0.34899 0.58807,0.43001 0.58728,0.45723 -0.0335,1.15449 -1.36508,1.5333 -3.91911,2.20901 -5.99126,1.58508 z",
    id: "path7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 317.88556,75.241705 c -1.34365,-0.41498 -2.60978,-1.74505 -3.00063,-3.15215 -0.17729,-0.63828 -0.32315,-3.0685 -0.32414,-5.4005 l -0.002,-4.24 h 0.96 0.96 v 4.46494 c 0,4.89204 0.24509,5.87441 1.64641,6.59906 1.81701,0.93961 4.28353,0.3022 5.01129,-1.29506 0.23804,-0.52245 0.3823,-2.52385 0.3823,-5.304 v -4.46494 h 0.98872 0.98872 l -0.10872,4.88 c -0.11978,5.37662 -0.4105,6.33867 -2.24241,7.42081 -1.11315,0.65756 -3.88419,0.91667 -5.25976,0.49184 z",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 291.03901,75.178165 c -2.75598,-0.97712 -4.13633,-3.08923 -4.13633,-6.32911 0,-3.51457 1.54824,-5.62054 4.71898,-6.41894 1.75323,-0.44147 3.9199,-0.0304 5.40195,1.02494 3.09499,2.20382 3.10847,8.6087 0.0226,10.75811 -1.86095,1.29623 -4.07145,1.65133 -6.00724,0.965 z m 4.35268,-1.93549 c 2.94435,-1.96695 2.94435,-6.82029 0,-8.78724 -2.98925,-1.99695 -6.75169,0.45143 -6.75169,4.39362 0,2.80079 2.02887,5.12 4.47901,5.12 0.69967,0 1.63087,-0.29763 2.27268,-0.72638 z",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 192.47901,75.178165 c -2.75598,-0.97712 -4.13633,-3.08923 -4.13633,-6.32911 0,-3.51457 1.54824,-5.62054 4.71898,-6.41894 1.75323,-0.44147 3.9199,-0.0304 5.40195,1.02494 3.09499,2.20382 3.10847,8.6087 0.0226,10.75811 -1.86095,1.29623 -4.07145,1.65133 -6.00724,0.965 z m 4.35268,-1.93549 c 2.94435,-1.96695 2.94435,-6.82029 0,-8.78724 -2.98925,-1.99695 -6.75169,0.45143 -6.75169,4.39362 0,2.80079 2.02887,5.12 4.47901,5.12 0.69967,0 1.63087,-0.29763 2.27268,-0.72638 z",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    style: {
      fill: "url(#linearGradient51)"
    },
    d: "m 89.919009,89.004485 c -7.63918,-0.59473 -14.832685,-3.05157 -21.236694,-7.25309 -3.238195,-2.12451 -8.699039,-7.66726 -10.915905,-11.07963 -2.996738,-4.61281 -4.94927,-9.63061 -6.125829,-15.74271 -0.747843,-3.88497 -0.749085,-11.70068 -0.0025,-15.84 1.548332,-8.58467 5.406843,-16.11398 11.23324,-21.92 C 70.445747,9.6211242 80.309473,5.4571946 91.839025,4.9404746 103.9273,4.3987246 114.00637,8.0800142 121.76551,15.870865 c 2.56471,2.57519 6.591,7.93479 6.53107,8.69384 -0.0123,0.15639 -3.30252,1.89109 -7.3115,3.85488 l -7.28906,3.57054 -1.33104,-2.02452 c -2.89197,-4.39869 -8.34992,-8.10859 -13.670792,-9.29237 -3.31017,-0.73644 -8.949073,-0.50646 -12.135163,0.49493 -4.834711,1.51956 -9.290579,4.5854 -12.151119,8.36053 -1.826871,2.41097 -4.040737,6.9631 -4.805182,9.88036 -0.832176,3.17574 -1.011239,10.14182 -0.345189,13.4289 1.776903,8.76938 6.933126,15.51897 14.463992,18.93363 3.106513,1.40856 5.909138,1.97351 9.877501,1.9911 4.17956,0.0185 6.564052,-0.52634 10.240002,-2.33988 4.11458,-2.02994 6.09555,-3.85691 9.6103,-8.8632 0.27666,-0.39406 1.51091,0.10106 7.6,3.04873 3.99833,1.93555 7.2697,3.62049 7.2697,3.7443 0,0.58971 -3.71566,5.68547 -5.74891,7.88423 -8.0049,8.65648 -19.48195,12.79286 -32.651095,11.76762 z m -66.24,-28.31543 v -24.8 h 7.68 7.68 v 24.8 24.8 h -7.68 -7.68 z m 4.260572,-35.29489 c -5.017703,-1.79258 -7.734953,-5.86869 -7.386049,-11.07971 0.270799,-4.04449 2.318473,-7.1132904 5.933212,-8.8919604 1.914333,-0.94197 2.429293,-1.05326 4.866568,-1.05172 2.332019,0.002 2.988683,0.13061 4.546525,0.89416 2.361781,1.15757 4.81525,3.8215296 5.581573,6.0604304 0.74015,2.16243 0.74015,5.36495 0,7.52738 -0.758285,2.21542 -3.221865,4.90435 -5.526292,6.0318 -2.344526,1.14707 -5.644004,1.35685 -8.015537,0.50962 z m 5.704726,-2.99649 c 1.61174,-0.48289 3.635574,-2.23282 4.513903,-3.903 0.956382,-1.81861 0.964921,-4.98069 0.01827,-6.76562 -3.001221,-5.6588604 -10.876936,-5.6998004 -13.681828,-0.0711 -3.033127,6.08669 2.602231,12.7014 9.149656,10.73974 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2a65",
      fillOpacity: 1
    },
    d: "m 148.15109,91.708225 c -0.50657,-1.33239 -0.40874,-82.6487008 0.10065,-83.6591708 0.54387,-1.0788596 1.66325,-1.2105196 2.20562,-0.2594196 0.61469,1.0779396 0.62482,82.9437304 0.0104,84.0194204 -0.58443,1.02318 -1.91127,0.96543 -2.31666,-0.10083 z",
    id: "path1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcvcmFullRes);
export default __webpack_public_path__ + "static/media/ICVCMFullRes.06e45375329ec3b61f82d696ba39eec2.svg";
export { ForwardRef as ReactComponent };